import Vue from 'vue';
import Vuex from 'vuex';
import '../../initialize'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        // 状态对象//tomcat存储照片的端口，通过Nginx代理
        baseApi: '/static',
        // 原始地址（备用）:
        // baseApi: 'http://39.107.231.57:8088/',
        // baseApi: 'http://localhost:8088/',
        // 未处理消息数量
        messageNum: 0
    },
    mutations: {
        // 更改状态的方法
        SET_MESSAGE_NUM(state, num) {
            state.messageNum = num;
        }
    },
    actions: {
        // 触发mutations中方法的方法
        getMessageNum({ commit }) {
            return Vue.prototype.$api.getMessageNum().then(res => {
                if (res.code == 200) {
                    commit('SET_MESSAGE_NUM', res.data);
                }
                return res;
            });
        }
    },
    getters: {
        // 用于从 store 中的 state 中派生出一些状态
        messageNum: state => state.messageNum
    },
    modules: {
        // 可以将store拆分成多个模块
    }
});